"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    mounted() {
        this.el.addEventListener("click", () => {
            window.open(window.location.origin + this.el.dataset["videoLink"], "embask_organizer_video_chat");
        });
    }
};
